import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import MessageModal from '@wix/da-ds/pkg/modals/dsPresets/MessageModal';
// @dynamic-i18n-keys
// Full key variations for dynamic t() at lines 39, 40, 43, 60, 69 (damz.modal.groupOrChannelFullModal.${roomType}${isUpsell ? '.upsell' : ''}.*; roomType multi|community):
//   damz.modal.groupOrChannelFullModal.multi.title
//   damz.modal.groupOrChannelFullModal.multi.message
//   damz.modal.groupOrChannelFullModal.multi.cancel
//   damz.modal.groupOrChannelFullModal.multi.confirm
//   damz.modal.groupOrChannelFullModal.multi.upsell.title
//   damz.modal.groupOrChannelFullModal.multi.upsell.message
//   damz.modal.groupOrChannelFullModal.multi.upsell.cancel
//   damz.modal.groupOrChannelFullModal.multi.upsell.confirm
//   damz.modal.groupOrChannelFullModal.community.title
//   damz.modal.groupOrChannelFullModal.community.message
//   damz.modal.groupOrChannelFullModal.community.cancel
//   damz.modal.groupOrChannelFullModal.community.confirm
//   damz.modal.groupOrChannelFullModal.community.upsell.title
//   damz.modal.groupOrChannelFullModal.community.upsell.message
//   damz.modal.groupOrChannelFullModal.community.upsell.cancel
//   damz.modal.groupOrChannelFullModal.community.upsell.confirm
import { Warning } from '@wix/da-ds/pkg/Icons/Confirmations/Warning';
import { CancelButton } from '@wix/da-ds/pkg/modals/dsPresets/MessageModal/buttons';
import BuyCoreBrandedButton from '@wix/da-shared-react/pkg/Button/core/dsPresets/BuyCoreBrandedButton';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import { BiData, BuyCoreButtonBiEvent } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';

import s from './GroupOrChannelFullModal.scss';

const LOCALE_KEY = 'damz.modal.groupOrChannelFullModal';

export interface Props {
  roomType: 'multi' | 'community';
  isUpsell?: boolean;
  requestClose: () => void;
}

const GroupOrChannelFullModal: React.FC<Props> = ({ roomType, isUpsell, requestClose }) => {
  const isMobile = useContext(MobileContext);
  const { t } = useTranslation('damz');
  const localeBase = `${LOCALE_KEY}.${roomType}${isUpsell ? '.upsell' : ''}`;

  return (
    <MessageModal
      className={s['root']}
      isOpen
      variant={isMobile ? 'vertical' : 'horizontal'}
      isFullscreen={false}
      image={<Warning />}
      onRequestClose={requestClose}
      title={t(`${localeBase}.title`)}
      message={t(`${localeBase}.message`)}
      footerButtons={[
        <CancelButton key="cancel" onClick={requestClose}>
          {t(`${localeBase}.cancel`)}
        </CancelButton>,

        isUpsell ? (
          <BuyCoreBrandedButton
            key="confirm"
            size="large"
            withMobileDefaultLabel={false}
            rel="noopener"
            referer={typeof window !== 'undefined' ? window.location.href : undefined}
            biData={BiData<BuyCoreButtonBiEvent>({
              evid: 375,
              referral_info: ReferralType.MESSAGES_ADD_TO_CHANNEL,
            })}
          >
            {t(`${localeBase}.confirm`)}
          </BuyCoreBrandedButton>
        ) : (
          <BrandedButton key="confirm" size="large" variant="brand-green" onClick={requestClose}>
            {t(`${localeBase}.confirm`)}
          </BrandedButton>
        ),
      ]}
    />
  );
};

export default GroupOrChannelFullModal;
